export { default as Img200 } from './processed/200/Valkyrie.jpg';
export { default as Img400 } from './processed/400/Valkyrie.jpg';
export { default as Imgthumb } from './processed/thumb/Valkyrie.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Valkyrie.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Valkyrie.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      180,
      6,
      7
    ],
    "_population": 313,
    "_hsl": [
      0.9990421455938697,
      0.9354838709677419,
      0.3647058823529412
    ]
  },
  "LightVibrant": {
    "_rgb": [
      235,
      180,
      180
    ],
    "_population": 31,
    "_hsl": [
      0,
      0.5789473684210522,
      0.8137254901960784
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      109,
      15,
      17
    ],
    "_population": 17,
    "_hsl": [
      0.9964539007092199,
      0.7580645161290323,
      0.24313725490196078
    ]
  },
  "Muted": {
    "_rgb": [
      164,
      92,
      84
    ],
    "_population": 1,
    "_hsl": [
      0.016666666666666663,
      0.32258064516129037,
      0.4862745098039216
    ]
  },
  "LightMuted": {
    "_rgb": [
      196,
      150,
      150
    ],
    "_population": 3,
    "_hsl": [
      0,
      0.2804878048780488,
      0.6784313725490196
    ]
  },
  "DarkMuted": {
    "_rgb": [
      90,
      66,
      62
    ],
    "_population": 4,
    "_hsl": [
      0.023809523809523846,
      0.18421052631578952,
      0.2980392156862745
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Valkyrie.js